import { Interceptor } from '@connectrpc/connect';

export function GrpcGlobalErrorInterceptor(notification: {
  error: (msg: string) => void;
}): Interceptor {
  return (next) => async (req) => {
    const res = await next(req);
    const succesErrorExpresion = RegExp('^AUTH-0\\d\\d$');
    const code = (res as unknown as Record<string, string>)?.['code'];
    if (succesErrorExpresion.test(code)) {
      const message =
        (res as unknown as Record<string, string>)?.['message'] ?? 'Error desconocido';
      notification.error(message);
    }
    return res;
  };
}
